import "./AmericanStandardToiletRepair.module.css";
import Header from "@/reusable_sections/Header";
import AmericanHero from "./sections/AmericanHero";
import AmericanToilets from "./sections/AmericanToilets";
import StandardFaq from "./sections/StandardFaq";
import Footer from "@/reusable_sections/Footer";
export default function AmericanStandardToiletRepairPage() {
  return <div>
      <Header />
      <AmericanHero />
      <AmericanToilets />
      <StandardFaq />
      <Footer />
    </div>;
}